import React, { PropsWithChildren } from "react";
import * as styles from "./DisclaimerText.module.scss";

const DisclaimerText: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles.disclaimer}>{children}</div>;
};

export default DisclaimerText;
